import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";
(() => {
  if (!customElements.get("collection-custom-tabs")) {
    class CollectionCustomTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.setVariables();
        this.initSwiper();
      }

      setVariables() {
        this.slidesPerViewDesktop = this.getAttribute("data-columns-desktop");
      }

      initSwiper() {
        new Swiper(this, {
          slidesPerView: "auto",
          spaceBetween: 0,
          navigation: false,
          pagination: false,
        });
      }
    }

    customElements.define("collection-custom-tabs", CollectionCustomTabs);
  }
})();
